import { render } from "./storeAdd.vue?vue&type=template&id=79cb20e4"
import script from "./storeAdd.vue?vue&type=script&lang=js"
export * from "./storeAdd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__